import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnDestroy } from '@angular/core';
import { ImageUtilService } from '../../shared/image-util-service/image-util.service';
import { OeAppPersonService } from '../../shared/oe-app-person.service';
import { MODAL_DATA } from '../../shared/tokens/modal-data.token';
import { TeacherFeedbackDto } from '../teacher-feedback-service/teacher-feedback-dto';
import { forkJoin, of, Subscription } from 'rxjs';
import { debounceTime, delay } from 'rxjs/operators';
import { formatTeacherResponseText } from '../../shared/utils/text-utils';

export interface AskATeacherFeedbackModalData {
  feedback: TeacherFeedbackDto;
}

const AVATAR_SIZE = 42;

@Component({
  selector: 'lp2-ask-a-teacher-feedback-modal',
  templateUrl: './ask-a-teacher-feedback-modal.component.html',
  styleUrls: ['./ask-a-teacher-feedback-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AskATeacherFeedbackModalComponent implements OnDestroy {
  public studentAvatar = { image: '' };
  public teacherAvatar = { image: '' };
  public isLoading = false;
  public feedback: TeacherFeedbackDto;
  public studentName = null;

  private subscription: Subscription;

  constructor(
    private imageUtilService: ImageUtilService,
    private readonly oeAppPersonService: OeAppPersonService,
    @Inject(MODAL_DATA) public readonly data: AskATeacherFeedbackModalData,
    private readonly cdRef: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.feedback = this.data.feedback;
    this.feedback.response.text = formatTeacherResponseText(this.feedback.response.text);

    this.studentName = this.oeAppPersonService.getPersonData().displayName;
    this.setAvatars();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  private setAvatars() {
    this.isLoading = true;
    this.cdRef.detectChanges();

    const studentAvatar$ = this.imageUtilService.getProfilePicAsDataUrl(
      this.studentAvatar,
      AVATAR_SIZE,
      AVATAR_SIZE,
      this.feedback.studentId
    );

    const teacherAvatar$ = this.feedback.response
      ? this.imageUtilService.getProfilePicAsDataUrl(
          this.teacherAvatar,
          AVATAR_SIZE,
          AVATAR_SIZE,
          this.feedback.response.teacherId
        )
      : of(null);

    this.subscription = forkJoin([studentAvatar$, teacherAvatar$])
      .pipe(delay(100))
      .subscribe(() => {
        this.isLoading = false;
        this.cdRef.detectChanges();
      });
  }
}



// WEBPACK FOOTER //
// ./ts/app/teacher-feedback/ask-a-teacher-feedback-modal/ask-a-teacher-feedback-modal.component.ts